<template>
  <vx-card>

    <vs-row class=" w-full mb-4">
      <vs-col class="w-full" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>팝업제목</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-input></vs-input>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-full mb-4 py-2">
      <vs-col class="w-full" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>팝업타입</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-radio class="mr-10" v-model="popup_type" vs-value="popup_type:1">새창형식</vs-radio>
          <vs-radio class="mr-10" v-model="popup_type" vs-value="popup_type:2">레이어형식</vs-radio>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-full mb-4">
      <vs-col class="w-full" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>팝업위치</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-col class="w-1/4" vs-type="flex" vs-align="center">
            <label class="fix-title-small">왼쪽 : </label>
            <vs-input class="w-full pl-2 pr-12"></vs-input>
          </vs-col>
          <vs-col class="w-1/4" vs-type="flex" vs-align="center">
            <label class="fix-title-small">위쪽 : </label>
            <vs-input class="w-full pl-2 pr-12"></vs-input>
          </vs-col>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-full mb-4">
      <vs-col class="w-full" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>팝업사이즈</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-col class="w-1/4" vs-type="flex" vs-align="center">
            <label class="fix-title-small">가로 : </label>
            <vs-input class="w-full pl-2 pr-12"></vs-input>
          </vs-col>
          <vs-col class="w-1/4" vs-type="flex" vs-align="center">
            <label class="fix-title-small">세로 : </label>
            <vs-input class="w-full pl-2 pr-12"></vs-input>
          </vs-col>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-full mb-4">
      <vs-col class="w-full" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>시작일</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <date-selector class="mr-4"></date-selector>
          <vs-select autocomplete class="mr-8" v-model="start_date_hh">
            <vs-select-item value="0" text="00시"/>
            <vs-select-item value="1" text="01시"/>
            <vs-select-item value="2" text="02시"/>
            <vs-select-item value="3" text="03시"/>
            <vs-select-item value="4" text="04시"/>
            <vs-select-item value="5" text="05시"/>
            <vs-select-item value="6" text="06시"/>
            <vs-select-item value="7" text="07시"/>
            <vs-select-item value="8" text="08시"/>
            <vs-select-item value="9" text="09시"/>
            <vs-select-item value="10" text="10시"/>
            <vs-select-item value="11" text="11시"/>
            <vs-select-item value="12" text="12시"/>
            <vs-select-item value="13" text="13시"/>
            <vs-select-item value="14" text="14시"/>
            <vs-select-item value="15" text="15시"/>
            <vs-select-item value="16" text="16시"/>
            <vs-select-item value="17" text="17시"/>
            <vs-select-item value="18" text="18시"/>
            <vs-select-item value="19" text="19시"/>
            <vs-select-item value="20" text="20시"/>
            <vs-select-item value="21" text="21시"/>
            <vs-select-item value="22" text="22시"/>
            <vs-select-item value="23" text="23시"/>
          </vs-select>
          <vs-select autocomplete v-model="start_date_mm">
            <vs-select-item value="0" text="00분"/>
            <vs-select-item value="5" text="05분"/>
            <vs-select-item value="10" text="10분"/>
            <vs-select-item value="15" text="15분"/>
            <vs-select-item value="20" text="20분"/>
            <vs-select-item value="25" text="25분"/>
            <vs-select-item value="30" text="30분"/>
            <vs-select-item value="35" text="35분"/>
            <vs-select-item value="40" text="40분"/>
            <vs-select-item value="45" text="45분"/>
            <vs-select-item value="50" text="50분"/>
            <vs-select-item value="55" text="55분"/>
          </vs-select>
        </vs-col>
      </vs-col>

    </vs-row>

    <vs-row class=" w-full mb-4">
      <vs-col class="w-full" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>마감일</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <date-selector class="mr-4"></date-selector>
          <vs-select autocomplete class="mr-8" v-model="end_date_hh">
            <vs-select-item value="0" text="00시"/>
            <vs-select-item value="1" text="01시"/>
            <vs-select-item value="2" text="02시"/>
            <vs-select-item value="3" text="03시"/>
            <vs-select-item value="4" text="04시"/>
            <vs-select-item value="5" text="05시"/>
            <vs-select-item value="6" text="06시"/>
            <vs-select-item value="7" text="07시"/>
            <vs-select-item value="8" text="08시"/>
            <vs-select-item value="9" text="09시"/>
            <vs-select-item value="10" text="10시"/>
            <vs-select-item value="11" text="11시"/>
            <vs-select-item value="12" text="12시"/>
            <vs-select-item value="13" text="13시"/>
            <vs-select-item value="14" text="14시"/>
            <vs-select-item value="15" text="15시"/>
            <vs-select-item value="16" text="16시"/>
            <vs-select-item value="17" text="17시"/>
            <vs-select-item value="18" text="18시"/>
            <vs-select-item value="19" text="19시"/>
            <vs-select-item value="20" text="20시"/>
            <vs-select-item value="21" text="21시"/>
            <vs-select-item value="22" text="22시"/>
            <vs-select-item value="23" text="23시"/>
          </vs-select>
          <vs-select autocomplete v-model="end_date_mm">
            <vs-select-item value="0" text="00분"/>
            <vs-select-item value="5" text="05분"/>
            <vs-select-item value="10" text="10분"/>
            <vs-select-item value="15" text="15분"/>
            <vs-select-item value="20" text="20분"/>
            <vs-select-item value="25" text="25분"/>
            <vs-select-item value="30" text="30분"/>
            <vs-select-item value="35" text="35분"/>
            <vs-select-item value="40" text="40분"/>
            <vs-select-item value="45" text="45분"/>
            <vs-select-item value="50" text="50분"/>
            <vs-select-item value="55" text="55분"/>
          </vs-select>
        </vs-col>
      </vs-col>

    </vs-row>

    <vs-row class=" w-full mb-4">
      <vs-col class="w-full" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>연결링크</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-input class="w-1/2"></vs-input>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-full mb-4">
      <vs-col class="w-full" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>게시페이지</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-select id="tableSelect" autocomplete label="" v-model="fromBoard" class="w-1/12">
            <vs-select-item :key="index" :value="item.id" :text="item.board_title"
                            v-for="(item,index) in boardList"/>
          </vs-select>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-full mb-4">
      <vs-col class="w-full py-2" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>활성여부</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-switch v-model="use_popup" style="width:54px">
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-ful mb-4 py-2">
      <vs-col class="w-full" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>노출 숨기기</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-radio class="mr-10" v-model="cookie_set" vs-value="cookie_set:1">사용안함</vs-radio>
          <vs-radio class="mr-10" v-model="cookie_set" vs-value="cookie_set:2">오늘 하루 보지않기</vs-radio>
          <vs-radio class="mr-10" v-model="cookie_set" vs-value="cookie_set:3">일주일간 숨기기</vs-radio>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-full">
      <vs-col class="w-full" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>내용</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <quill-editor class="vx-col flex-1 ql-edit-text" v-model="contentInput" :options="quillOption"></quill-editor>
        </vs-col>
      </vs-col>
    </vs-row>

  </vx-card>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {quillEditor} from 'vue-quill-editor'
import DateSelector from '@/views/components/DateSelector'

export default {
  name: 'AdminPopupUpdate',
  components: {
    DateSelector,
    quillEditor
  },
  data () {
    return {
      quillOption: {
        placeholder: '내용을 입력해주세요 ...'
      },
      popup_type:'popup_type:1',
      contentInput:'',
      start_date_hh:0,
      start_date_mm:0,
      end_date_hh:0,
      end_date_mm:0,
      boardList:[],
      fromBoard:{},
      use_popup:false,
      cookie_set:'cookie_set:1'
    }
  },
  created () {
    this.loadBoardList()
  },

  methods : {
    async loadBoardList () {
      await this.$store.dispatch('board/LOAD_BOARD_LIST')
      this.boardList = this.$store.state.board.list
    }
  }

}
</script>

<style >
.fix-title { width:180px !important; }
.fix-title-small { width:40px !important; }
.ql-edit-text .ql-editor {
  overflow-y: scroll;
  resize: vertical;
  min-height: 20em;
}
</style>

<style scoped>

</style>
